export default "/images/vendor/flag-icon-css/flags/4x3/sr.svg?f281cc96dc94e9f2bcdf35155d700dfa";